import RecoverStep from "./recover_step";
import {attachSelectableHandler, showVmsList} from "../utils/recover_utils";

const TEMPLATE = 'export-failover-vm';

export default class VmRunning extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        let vmdk_disabled = false;
        let bmr = false;
        let transition = false;
        let testFailover = false;
        if (data.recovery.virtualization.vmdk_disabled) {
            vmdk_disabled = true;
        } else if (data.recovery.virtualization.bmr) {
            bmr = true;
        } else if (data.recovery.virtualization.transition) {
            transition = true;
        } else if (data.recovery.virtualization.testfailover) {
            testFailover = true;
        }

        data.render = {
            isLoading    : false,
            isSuccessful : false,
            clientId     : data.clientId,
            vmdkDisabled : vmdk_disabled,
            bmr          : bmr,
            transition   : transition,
            testFailover : testFailover,
            format       : data.recovery.virtualization.format
        };
        fr.render('vmRunning');
    }


    postRender(data, el, fr) {
        attachSelectableHandler(el,(d) => {
            data.restore.type = d.type;
        });
    }

    transitionViewService(data, el, fr) {
        showVmsList(data);
    }

    transitionBack(data, el, fr) {
        delete data.recovery.device_id;
        if(data.render.testFailover || data.render.bmr){
            fr.goTo('locateVirtualization');
        } else{
            fr.goTo(data.tmp.previousStep);
        }
    }

    transitionTryAgain(data, el, fr) {
        fr.goTo(data.tmp.vmRunning.tryAgain);
    }

}
